import * as React from 'react';
import { ActionClickHandler } from '../types';

interface Props {
  cell: {
    rowId: string;
    status: number;
  };
  handleClick: ActionClickHandler;
  isLoading: boolean;
}

export const ActionsGridTemplate = ({
  cell,
  handleClick,
  isLoading,
}: Props) => {
  const { status, rowId } = cell;

  const onClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    action?: 'delete' | 'form' | 'sign',
  ) => {
    handleClick(e, cell, action);
  };

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
      {status === 20 && (
        <div
          className="btn-group-vertical"
          role="group"
          style={{ width: '100%' }}
        >
          <button
            disabled={isLoading}
            className="btn btn-warning"
            data-id="PDF"
            onClick={(e) => {
              onClick(e, 'form');
            }}
          >
            {!isLoading ? 'Сформировать PDF' : 'Загрузка...'}
          </button>
        </div>
      )}
      {[21, 25, 1, 4, 11, 12, 13, 14].includes(status) && (
        <div
          className="btn-group-vertical btn-icon"
          role="group"
          style={{ width: '100%' }}
        >
          <button
            disabled={isLoading}
            className="btn btn-primary"
            data-id="SIGN"
            onClick={(e) => {
              onClick(e, 'sign');
            }}
          >
            Подписать
          </button>
        </div>
      )}
      {/* TODO - добавить отображение кнопок в зависимости от статуса */}
      {status !== 20 ? (
        <div
          className="btn-group-vertical"
          role="group"
          style={{ width: '100%' }}
        >
          <button
            disabled={isLoading}
            className={`btn btn-danger`}
            onClick={(e) => {
              onClick(e, 'delete');
            }}
          >
            Удалить документы
          </button>
        </div>
      ) : null}
    </div>
  );
};
